/* eslint-disable import-x/no-default-export, no-restricted-exports, import-x/no-useless-path-segments */
// This file is auto-generated
export { default, getFullLocale } from '../src/lascanaat';
export type { Config, Locale, Language, GeoCountryCode } from '../src/default/types';
